import { getRequest } from "api/commonActions/get";
import { postRequest } from "api/commonActions/post";
import { patchRequest } from "api/commonActions/update";
import { Requests } from "config/api";
import { AxiosResponse } from "axios";
import {
  SparePartCategoryType,
  SparePartProductType,
  SparePartRequestStatusType,
  SparePartRequestType,
} from "types/loadedData";

export const GetSparePartCategories = async (): Promise<{
  status: number;
  categories: SparePartCategoryType[];
}> => {
  const response: AxiosResponse = await getRequest({
    route: Requests.get.getSparePartCategories,
  });
  return {
    status: response?.status,
    categories: response?.data?.categories || [],
  };
};

export const GetSparePartProducts = async (query: {
  search?: string;
  category?: string;
  make?: string;
  model?: string;
  year?: string;
  city?: string;
  limit?: number;
  offset?: number;
}): Promise<{
  status: number;
  products: SparePartProductType[];
  count: number;
}> => {
  const response: AxiosResponse = await getRequest({
    route: Requests.get.getSparePartProducts,
    queryParams: query,
  });
  return {
    status: response?.status,
    products: response?.data?.products || [],
    count: response?.data?.count || 0,
  };
};

export const GetSparePartRequests = async (query: {
  search?: string;
  status?: string;
  limit?: number;
  offset?: number;
}): Promise<{
  status: number;
  requests: SparePartRequestType[];
  count: number;
}> => {
  const response: AxiosResponse = await getRequest({
    route: Requests.get.getSparePartRequests,
    queryParams: query,
  });
  return {
    status: response?.status,
    requests: response?.data?.requests || [],
    count: response?.data?.count || 0,
  };
};

export const UpdateSparePartRequest = async ({
  id,
  status,
  quotedPrice,
  staffNotes,
}: {
  id: string;
  status?: SparePartRequestStatusType;
  quotedPrice?: string | number;
  staffNotes?: string;
}): Promise<{
  status: number;
  request: SparePartRequestType;
}> => {
  const response: AxiosResponse = await patchRequest({
    route: Requests.update.updateSparePartRequest,
    pathVariables: { id },
    payload: { status, quotedPrice, staffNotes },
  });
  return {
    status: response?.status,
    request: response?.data?.request,
  };
};

export const CreateSparePartProduct = async (
  payload: Partial<SparePartProductType>
): Promise<{
  status: number;
  product: SparePartProductType;
}> => {
  const response: AxiosResponse = await postRequest({
    route: Requests.post.createSparePartProduct,
    payload,
  });
  return {
    status: response?.status,
    product: response?.data?.product,
  };
};
